export const convertToValue = (
  obj: any, key: any
) => {
  if (Object.values(obj).includes(key)) {
    return key;
  }

  return Object.entries(obj).find((entry: any) => entry[0] === key)?.[1];
}

export const convertToKey = (
  obj: any, value: any
) => {
  if (Object.keys(obj).includes(value)) {
    return value;
  }

  return Object.entries(obj).find((entry: any) => entry[1] === value)?.[0];
}